// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 获取省市列表
export const _getProvinceAndCityList = (params) => {
    return getRequest('/config/getProvinceAndCityList', params)
};

//个人认证提交
export const _getpersonRealName = (params) => {
    return postRequest('/realName/personRealName', params)
};

//企业认证第一步
export const _enterpriseRealNameFirst = (params) => {
    return postRequest('/realName/enterpriseRealNameFirst', params)
};

//企业认证第二部
export const _enterpriseRealNameSecond = (params) => {
    return postRequest('/realName/enterpriseRealNameSecond', params)
};

//获取用户实名信息

export const _findMainObligee = (params) => {
    return getRequest('/powerUser/findMainObligee', params)
};


